import Loadable from '../components/common/Loadable'
import { lazy } from 'react'

const LoginPage = Loadable(lazy(() => import('../pages/auth/LoginPage')))

const NoAuthRoutes = {
  path: '/',
  children: [
    {
      path: 'login',
      layoutType: 'particleBackground',
      element: <LoginPage />,
    },
  ],
}

export default NoAuthRoutes
